import apiConfig from '../../../config/api'
import { apiRequestorHelper } from '../../../helpers'

const uploadFooterPortal = (formData) => {
  return apiRequestorHelper({
    url: apiConfig.url + '/uploadFooterPortal',
    method: 'post',
    body: formData
  })
    .then((response) => {
      return { success: true, data: response.data }
    })
    .catch((error) => {
      throw error.response || error
    })
}

export default uploadFooterPortal
